<template>
  <span>
    <icon-base viewBox='0 0 16 8'><component :is="iconComponent" /></icon-base>
  </span>
</template>

<script>
import IconBase from "../Icons/IconBase.vue";
import IconRegionalMenager from "../Icons/IconRegionalMenager.vue";
import IconCentralOffice from "../Icons/IconCentralOffice.vue";
import IconDefaultDepartment from "../Icons/IconDefaultDepartment.vue";
export default {
  props: {
    departmentName: {
        Type: String,
        Default: 'default'
    },
  },
  components: {
    IconBase,
    IconRegionalMenager,
    IconCentralOffice,
    IconDefaultDepartment
  },
  data: () => ({
    icon: "calendar",
  }),
  watch: {},
  computed: {
    iconComponent() {
      switch (this.departmentName) {
      case 'SPV':
      case 'TMR':
      case 'RM':
      case 'DM':
      case 'Filo':
      case 'Fleet':
      case 'Key Account TMR':
      case 'MT':
        return IconRegionalMenager;
      case 'Business Development':
      case 'HQ':
      case 'ARGE':
      case 'Developers':
      case 'Dijital İş Çözümleri':
      case 'DIST Planner':
      case 'Fabrika':
      case 'Finans':
      case 'Güvenlik':
      case 'Horeca':
      case 'İnsan Kaynakları':
      case 'IT':
      case 'MUHASEBE':
      case 'Mutfak ve Temizlik':
      case 'Ofis Asistanı':
      case 'Operasyon':
      case 'Planlama Altbayi':
      case 'PLANNER':
        return IconCentralOffice;
      default:
        return IconDefaultDepartment;
    }
    },
  },
};
</script>

<style></style>
